/**
 * @typedef {String} module:EventService.StatusEnum
 * @readonly
 * @description The list of values that the status property of an event can have
 * @property {String} open "OPEN" The event is ongoing, and the duration and other event properties may change
 * @property {String} processing "PROCESSING" MW is still working on the event and properties may change
 * @property {String} prefinalizing "PREFINALIZING" MW is still working on the event and properties may change
 * @property {String} finalizing "FINALIZING" MW is still working on the event and properties may change
 * @property {String} finalized "FINALIZED" This is the normal state of most events
 * @property {String} errorProcessing "ERROR_PROCESSING"
 * @property {String} errorFinalizing "ERROR_FINALIZING"
 * @property {String} deleted "DELETED" These are not shown to the user
 * @property {String} hidden "HIDDEN" These are not shown to the user
 */

const statusEnum = Object.freeze({
    open: 'OPEN',
    processing: 'PROCESSING',
    prefinalizing: 'PREFINALIZING',
    finalizing: 'FINALIZING',
    finalized: 'FINALIZED',
    errorProcessing: 'ERROR_PROCESSING',
    errorFinalizing: 'ERROR_FINALIZING',
    deleted: 'DELETED',
    hidden: 'HIDDEN'
});

export default statusEnum;
